
const baseUrl = 'https://badactorapplication-transactionservicedev.westeurope.dev.maersk.io/api';
const baseAnalyticsUrl = 'https://badactorapplication-analyticsservicedev.westeurope.dev.maersk.io/api/Analytics';
const weightinFactorsUrl = 'https://badactorapplication-weightingfactorservicedev.westeurope.dev.maersk.io/weightingfactors';
const baseActionTypesUrl = 'https://badactorapplication-actiontypeservicedev.westeurope.dev.maersk.io/api/ActionType';
//const baseActionTypesUrl = 'https://api-cdt.apmterminals.com/badactorapplication-actiontypeservicedev/api/ActionType';

const languageTransalationUrl = 'https://badactorapplication-languagemappingservicedev.westeurope.dev.maersk.io/languagemapping';
const rolloutUrl="https://badactorapplication-rollouttrackingservicedev.westeurope.dev.maersk.io/api/RolloutImplementation";
const identificationPrioritizationUrl = 'https://badactorapplication-cubejswrapperservicedev.westeurope.dev.maersk.io/cubejswrapper';
const cubejsWrapperUrl =
  "https://badactorapplication-cubejswrapperservicedev.westeurope.dev.maersk.io/cubejswrapper";
  
const criticalAssetTypesUrl = 'https://badactorapplication-criticalassettypeservicedev.westeurope.dev.maersk.io/criticalassettypes';
const counterMeasureUrl = 'https://badactorapplication-countermeasureservicedev.westeurope.dev.maersk.io/api';
const roleEndPoint="https://apmtdigitalamtechasset-userservicedev.westeurope.dev.maersk.io";
const reccomendationApiEndPoint = "https://badactorapplication-recommendationservicedev.westeurope.dev.maersk.io/api";
const symptomsApiEndPoint = "https://badactorapplication-symptomsservicedev.westeurope.dev.maersk.io/api";
const failureModeApiEndPoint = "https://badactorapplication-failuremodeservicedev.westeurope.dev.maersk.io/api";


export const environment = {
  production: false,
  apiEndpoint: baseUrl,
  analyticsApiEndPoint: baseAnalyticsUrl,
  weightinFactorsUrlEndPoint: weightinFactorsUrl,
  actionTypesApiEndPoint: baseActionTypesUrl,
  languageTransalationEndPoint: languageTransalationUrl,
  cubejsWrapperEndPoint: cubejsWrapperUrl,
  rolloutUrlEndPoint:rolloutUrl,
  identificationPrioritizationEndPoint:identificationPrioritizationUrl,
  criticalAssetTypesEndPoint:criticalAssetTypesUrl,
  counterMeasureEndPoint:counterMeasureUrl,
  roleEndPoint:roleEndPoint,
  reccomendationApiEndPoint:reccomendationApiEndPoint,
  symptomsApiEndPoint:symptomsApiEndPoint,
  failureModeApiEndPoint:failureModeApiEndPoint,

  msalConfig: {
    auth: {
      clientId: "ec849bcb-fee1-4fc9-98c5-f19aff4309e9",
      authority:
        "https://login.microsoftonline.com/05d75c05-fa1a-42e7-9cf1-eb416c396f2d",
    },
  },
  apiConfig: {
    scopes: ["api://ec849bcb-fee1-4fc9-98c5-f19aff4309e9/access"],
    uri: "https://graph.microsoft.com/v1.0/me",
  },
  rumConfig: {
    appName: "BadActor-dev",
    environment: "dev",
    apiKey: "JxsegjA4A5EGGgF983ZY01tk3NuKe/9Zxie4dvrsgdaP2xFCQPgZ/IBXTfLATw==",
  },
   gtmContainerId: 'GTM-M44QCF38',
  analyticsAppName : 'apmt-am-badactor'

};
